// extracted by mini-css-extract-plugin
export var content = "section-module--content--NHsK8";
export var hasMedia = "section-module--hasMedia--HfmfP";
export var section = "section-module--section--RG9F+";